import { getPagePath, PREVIOUS_PAGE } from "./pageLinkSelectors";

export const getPreviousPagePath = state =>
  getPagePath({ state, direction: PREVIOUS_PAGE });
